<app-header></app-header>
<app-botao-chat></app-botao-chat>

<div class="container py-4">
<div class="row">
<div class="col-12">
      <div class="card">
        <app-breadcrumb></app-breadcrumb>
        <h1 class="titulo">Painel de Manutenções
            <button class="botao-setinha-voltar btn-icon" (click)="goBackPage('painel-de-manutencoes', 'painel-de-manutencoes', 'pagina')">
                  <i class="fa fa-arrow-left" aria-hidden="true"></i>
            </button>
        </h1>
            <p class="paragrafo mb-4">Ferramenta para exclusão de produtos e endereço</p>

            <!-- ABAS NAVEGAÇÃO -->
            <ul class="nav nav-tabs mt-5 border-0" id="myTab">
                  <li class="nav-item me-3">
                    <a class="nav-link active" id="endereco-tab" data-bs-toggle="tab" href="#endereco" aria-controls="endereco" (click)="addTagInPageChange('manutencao-de-endereco', 'painel-de-manutencoes', 'painel-de-manutencoes', 'pagina')">Manutenção de Endereço</a>
                  </li>
                  <li class="nav-item me-3">
                    <a class="nav-link" id="produto-tab" data-bs-toggle="tab" href="#produto" aria-controls="produto" (click)="addTagInPageChange('manutencao-de-produto', 'painel-de-manutencoes', 'painel-de-manutencoes', 'pagina')">Manutenção de Produto</a>
                  </li>
            </ul>

            <div class="tab-content mt-4" id="myTabContent">
                  <!-- CONTEÚDO DA ABA DE ENDEREÇO -->
                  <div class="tab-pane fade show active" id="endereco" role="tabpanel" aria-labelledby="endereco-tab">
                        <app-manutencao-endereco></app-manutencao-endereco>
                  </div>
                  <!-- CONTEÚDO DA ABA DE PRODUTO -->
                  <div class="tab-pane fade" id="produto" role="tabpanel" aria-labelledby="produto-tab">
                        <app-manutencao-produto></app-manutencao-produto>
                  </div>
            </div>

      </div>
</div>
</div>
</div>

<app-footer></app-footer>
